import * as RadixSwitch from '@radix-ui/react-switch';
import React from 'react';
import styles from './Switch.module.css';

export const Switch = (
  props: React.JSX.IntrinsicAttributes &
    RadixSwitch.SwitchProps &
    React.RefAttributes<HTMLButtonElement>,
) => {
  return (
    <RadixSwitch.Root className={styles.SwitchRoot} {...props}>
      <RadixSwitch.Thumb className={styles.SwitchThumb} />
    </RadixSwitch.Root>
  );
};
